import { Cloudinary } from '@cloudinary/url-gen';
import { limitFit } from '@cloudinary/url-gen/actions/resize';
import { isGif, transformCloudinaryGifToStill } from '../components/room/utils';

const CLOUDINARY_PRESET = 'zeybpe0h';
const CLOUDINARY_CLOUD_NAME = 'dqlqwdqs9';

export const uploadImageToCloudinary = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', CLOUDINARY_PRESET);
  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/upload`,
    {
      method: 'POST',
      body: formData,
    }
  );
  return response.json();
};

// Create and configure your Cloudinary instance.
export const cloudinary = new Cloudinary({
  cloud: {
    cloudName: CLOUDINARY_CLOUD_NAME,
  },
});

export const resizeImage = (imageId: string, width: number, height: number) =>
  cloudinary
    .image(imageId)
    .resize(limitFit().width(width).height(height))
    .toURL();

export const getAvatarSrc = (
  avatarPublicId: string,
  avatarUrl?: string,
  w?: number,
  h?: number
) => {
  return isGif(avatarUrl)
    ? transformCloudinaryGifToStill(avatarUrl)
    : resizeImage(avatarPublicId, w, h);
};
